import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { zip } from 'rxjs';
import { MachineFamillyService, ApplicationService } from '../../shared/services';
import { BaseModalPageComponent } from '../../base-modal.component';
import * as _ from 'lodash';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'machineselector',
  templateUrl: './machineSelector.component.html',
  standalone: false
})
export class MachineSelectorPageComponent extends BaseModalPageComponent implements OnInit {
  @ViewChild('modelsModal', { static: true })
  modal: ModalComponent;
  @ViewChild('productLinesModal', { static: true })
  productLinesModal: ModalComponent;

  public modelSelectedValue: string;

  public productLineSelectedValue: string;

  productLineId: string;
  categoryId: string;
  applicationSubType: number;
  inspectionId: string;

  categoriesForm: UntypedFormGroup;
  productLines: any[];
  categories: any[];
  machines: any[];
  machinesComboData: any[];
  isOptimization: boolean;
  machineId: string;
  serialNumber: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private machineFamillyService: MachineFamillyService,
    private applicationService: ApplicationService
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.applicationSubType = +params['applicationSubType'];
      this.inspectionId = params['inspectionId'];
      this.productLineId = params['productLineId'];
      this.machineId = params['machineId'];
      this.serialNumber = params['serialNumber'];
      this.initData();
    });
  }

  public initData() {
    zip(
      this.machineFamillyService.getCurrentScopeProductLines(),
      this.machineFamillyService.getCategories(),
      this.machineFamillyService.getModels(),
      this.applicationService.isOptimization()
    ).subscribe(([productLines, categories, machines, isOptimization]) => {
      this.productLines = _.orderBy(productLines, ['name']);
      this.categories = categories;
      this.machines = machines;
      this.isOptimization = isOptimization;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  public showMachineFamilySelector(): boolean {
    return this.categoriesForm ? this.categoriesForm.controls['productLineId'].value !== '' : false;
  }

  public showMachines(): boolean {
    return this.categoriesForm ? this.categoriesForm.controls['categoryId'].value !== '' : false;
  }

  initForm() {
    const nameControl = new UntypedFormControl('', this.applicationSubType ? [] : Validators.required);
    if (this.isOptimization) {
      this.categoriesForm = new UntypedFormGroup({
        productLineId: new UntypedFormControl(this.productLineId, Validators.required),
        name: nameControl,
        serialNumber: new UntypedFormControl(this.serialNumber)
      });
    } else {
      this.categoriesForm = new UntypedFormGroup({
        productLineId: new UntypedFormControl(this.productLineId, Validators.required),
        categoryId: new UntypedFormControl(this.categoryId, Validators.required),
        name: nameControl,
        serialNumber: new UntypedFormControl(this.serialNumber)
      });
    }

    if (this.productLineId) this.selectProductLinesMenu({ selectedIndex: this.productLineId });
    if (this.machineId) this.selectModelsMenu({ selectedIndex: this.machineId });
  }

  public openModelsSelector(): void {
    this.openSelector(
      this.modal,
      this.machinesComboData.map((m) => ({ label: `${m.serie} - ${m.name}`, value: m.id })),
      this.categoriesForm.controls['categoryId'].value?.id,
      { search: true }
    );
  }

  public openProductLinesSelector(): void {
    this.openSelector(
      this.productLinesModal,
      this.productLines.map((p) => ({ label: p.name, value: p.id })),
      this.categoriesForm.controls['productLineId'].value
    );
  }

  public selectModelsMenu(item: any) {
    const selectedMachine = this.machinesComboData.find((m) => m.id === item.selectedIndex);
    this.modelSelectedValue = `${selectedMachine.serie} - ${selectedMachine.name}`;
    this.categoriesForm.controls['categoryId'].setValue(selectedMachine);
  }

  public selectProductLinesMenu(item: any) {
    this.categoriesForm.controls['productLineId'].setValue(item.selectedIndex);
    this.productLineSelectedValue = this.productLines.find((pl) => pl.id === item.selectedIndex).name;
    if (!this.isOptimization) {
      const productLineId = this.categoriesForm.controls['productLineId'].value;
      let categories = _.filter(this.categories, ['productLineId', productLineId]);
      categories = _.map(categories, 'id');
      this.machinesComboData = _.orderBy(
        _.filter(
          this.machines,
          (m: any) =>
            (!m.hidden || m.id === this.machineId) &&
            _.find(categories, (c: any) => {
              return c == m.categoryId;
            }) !== undefined
        ),
        ['serie', 'name']
      );
      this.categoriesForm.controls['categoryId'].setValue(null);
      this.modelSelectedValue = '';
    }
  }

  save(model: any) {
    if (this.applicationSubType && this.inspectionId) {
      return this.router.navigate([
        this.inspectionsRoute,
        this.inspectionId,
        this.applicationSubType,
        'fromModel',
        model.productLineId,
        model.categoryId.categoryId,
        model.categoryId.id,
        model.serialNumber ?? ''
      ]);
    }

    if (this.isOptimization) {
      return this.router.navigate([this.inspectionsRoute, 'fromModel', model.productLineId, model.name, model.serialNumber ?? '']);
    }
    return this.router.navigate([
      this.inspectionsRoute,
      'fromModel',
      model.productLineId,
      model.categoryId.categoryId,
      model.categoryId.id,
      model.name,
      model.serialNumber ?? ''
    ]);
  }

  public onProductLinesMenuClose() {
    const data = <UntypedFormGroup>this.categoriesForm.controls['productLineId'];
    data.controls['ProductLine'].markAsTouched();
  }

  public onClose() {
    this.categoriesForm.controls['categoryId'].markAsTouched();
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }
}
